module.exports = __webpack_public_path__ + "img/Core_s25_b2_0_1_C00_UK.29a337b7.png";